'use client'

import s from './ModalWindow.module.scss';
import {TModalWindowProps} from "@/app/[locale]/common/components/ModalWindow/types";
import {CustomIconButton} from "@/app/[locale]/common/components/CustomIconButton/CustomIconButton";
import {CrossIcon} from "@/app/[locale]/common/assets/CrossIson/CrossIcon";
import ReactDOM from 'react-dom';
import {useEffect, useRef} from "react";
import {usePathname} from "@/i18n/routing";

export const ModalWindow = ({ isOpen, closeModalWindow, children }: TModalWindowProps) => {
    const pathname = usePathname();
    const prevPathnameRef = useRef<string>(pathname);
    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (pathname !== prevPathnameRef.current) {
            closeModalWindow();
        }

        prevPathnameRef.current = pathname;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                closeModalWindow();
            }
        };

        const handleClickOutside = (event: MouseEvent) => {
            if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
                closeModalWindow();
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
            document.addEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = "hidden";
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = "";
        };
    }, [isOpen, pathname, closeModalWindow]);

    if (!isOpen) {
        return null;
    }

    const modalContent = (
        <div className={s.overlay}>
            <div className={s.modalWindow} ref={modalRef}>
                <CustomIconButton
                    className={s.modalWindow_closeButton}
                    onClick={closeModalWindow}
                >
                    {
                        <span>
                            <CrossIcon/>
                        </span>
                    }
                </CustomIconButton>

                {
                    children
                }
            </div>
        </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
};